import { Card, Icon, Layout, Tag, Text } from '@loadsmart/miranda-react'

import { getProvidersForMethod } from '../../../domain/PreferredTrackingMethod'
import { type TrackingMethod, type TrackingProvider } from '../../../domain/Tracking'
import { formatPreferredProviderTagContent } from '../../../presenters/preferredTrackingMethod'
import TrackingProviderCard from './TrackingProviderCard'

export type PreferredProviderStepProps = {
  readonly selectedMethod?: TrackingMethod
  readonly selectedProvider?: TrackingProvider
  readonly onSelectProvider: (provider: TrackingProvider) => void
}

export default function PreferredProviderStep({
  selectedMethod,
  selectedProvider,
  onSelectProvider,
}: PreferredProviderStepProps) {
  const providersForMethod = getProvidersForMethod(selectedMethod)
  const hasProviders = providersForMethod.length > 0
  const tagContent = formatPreferredProviderTagContent(selectedMethod, selectedProvider)

  return (
    <Card collapsible={hasProviders}>
      <Card.Title leading={tagContent ? <Icon name="check" color="color-success-60" /> : undefined}>
        2. Preferred provider
        {tagContent && (
          <Tag variant="neutral" size="small">
            {tagContent}
          </Tag>
        )}
      </Card.Title>
      {hasProviders && (
        <>
          <Card.Subtitle>Choose the provider of your preference</Card.Subtitle>
          <Card.Divider />
          <Card.Body>
            <Layout.Stack gap="spacing-4">
              <Text variant="body-md" color="color-text-tertiary">
                Select the provider
              </Text>
              <Layout.Grid gap="spacing-2" minColumnWidth="220px">
                {providersForMethod.map(provider => (
                  <TrackingProviderCard
                    key={provider}
                    provider={provider}
                    onClick={() => onSelectProvider(provider)}
                    selected={selectedProvider === provider}
                  />
                ))}
              </Layout.Grid>
            </Layout.Stack>
          </Card.Body>
        </>
      )}
    </Card>
  )
}
